// extracted by mini-css-extract-plugin
module.exports = {"widget__item":"Widget_widget__item__1KOF5","widget__after-post-sidebar":"Widget_widget__after-post-sidebar__AWU9Q"};